export class FormAnswer {
    id: string;
    optionsSelection: string[];
    textAnswer: string;
}